export const useSnackbarStore = defineStore('snackbar', () => {
  // data
  const LIGHT_COLOR_SUCCESS = 'blue-lighten-2'
  const LIGHT_COLOR_ERROR = 'orange-darken-2'
  const DARK_COLOR_SUCCESS = 'blue-darken-3'
  const DARK_COLOR_ERROR = 'deep-orange-darken-3'

  const color = ref(LIGHT_COLOR_SUCCESS)
  const show = ref(false)
  const location = ref('top')
  const isVertical = ref(false)
  const text = ref('')
  const timeout = ref(3000)
  const logoutProcessing = ref(false)
  const callback = ref()

  // action
  function setColor(val) {
    setState({ key: 'color', value: val })
  }

  function setShow(val) {
    setState({ key: 'show', value: val })
  }

  function setText(val) {
    setState({ key: 'text', value: val })
  }

  function setMessageTimeout(val) {
    setState({ key: 'timeout', value: val })
  }

  function setCallback(val) {
    setState({ key: 'callback', value: val })
  }

  function clearSnackbar() {
    setState({ key: 'show', value: false })
    setState({ key: 'text', value: '' })
    setState({ key: 'timeout', value: 3000 })
    setState({ key: 'logoutProcessing', value: false })
    setState({ key: 'callback', value: null })
  }

  /**
   *
   * @param param0 context
   * @param param1 error | { error|messge|errorMessage, timeout } | message
   */
  async function showSnackbar(val) {
    const pimTheme = useCookie('pim_theme')
    const isDark = (pimTheme.value || 'light') === 'dark'
    const successColor = isDark ? DARK_COLOR_SUCCESS : LIGHT_COLOR_SUCCESS
    const failColor = isDark ? DARK_COLOR_ERROR : LIGHT_COLOR_ERROR

    setState({ key: 'timeout', value: 3000 })

    if (val instanceof Object) {
      if (val instanceof Error) {
        console.log(`showSnackbar()... Error : ${val}`)
        setTextFromError(val)
        setState({ key: 'color', value: failColor })
      } else {
        if (val.timeout) {
          setState({ key: 'timeout', value: val.timeout })
        }

        if (val.callback) {
          setState({ key: 'callback', value: val.callback })
        }

        location.value = val.location ? val.location : 'top'
        isVertical.value = val.vertical ? true : false

        if (val.error && val.error instanceof Error) {
          console.log(`showSnackbar()... val.error : ${val.error}`)
          setTextFromError(val.error)
          setState({ key: 'color', value: failColor })

          if (!!val.errorMessage) {
            setState({ key: 'text', value: `${val.errorMessage}\n\n(${text.value})` })
          }
        } else if (val.message) {
          //console.log('message: ', val.message)
          setState({ key: 'text', value: val.message })
          setState({ key: 'color', value: successColor })
        } else if (val.errorMessage) {
          console.log('errorMessage: ', val.errorMessage)
          setState({ key: 'text', value: val.errorMessage })
          setState({ key: 'color', value: failColor })
        }
      }
    } else {
      console.log('message: ', val)
      setState({ key: 'text', value: val })
      setState({ key: 'color', value: successColor })
    }

    setState({ key: 'show', value: true })

    if (val.sleep) {
      await g.sleep(val.sleep)
      setState({ key: 'show', value: false })
    }
  }

  // const sleep = (ms) => {
  //   return new Promise((resolve) => setTimeout(resolve, ms))
  // }

  /**
   *
   * @param param0 context
   * @param param1 error | { error|messge|errorMessage, timeout } | message
   */
  function showSnackbarNGoBack(val) {
    const pimTheme = useCookie('pim_theme')
    const isDark = (pimTheme.value || 'light') === 'dark'
    const successColor = isDark ? DARK_COLOR_SUCCESS : LIGHT_COLOR_SUCCESS
    const failColor = isDark ? DARK_COLOR_ERROR : LIGHT_COLOR_ERROR

    setState({ key: 'timeout', value: 3000 })

    if (val instanceof Object) {
      if (val instanceof Error) {
        setTextFromError(val)
        setState({ key: 'color', value: failColor })
      } else {
        if (val.timeout) {
          setState({ key: 'timeout', value: val.timeout })
        }

        if (val.error && val.error instanceof Error) {
          setTextFromError(val.error)
          setState({ key: 'color', value: failColor })
        } else if (val.message) {
          console.log('message: ', val.message)
          setState({ key: 'text', value: val.message })
          setState({ key: 'color', value: successColor })
        } else if (val.errorMessage) {
          console.log('errorMessage: ', val.errorMessage)
          setState({ key: 'text', value: val.errorMessage })
          setState({ key: 'color', value: failColor })
        }
      }
    } else {
      console.log('message: ', val)
      setState({ key: 'text', value: val })
      setState({ key: 'color', value: successColor })
    }

    setState({ key: 'show', value: true })

    const router = useRouter()
    setTimeout(() => {
      if (window.history.length > 1) router.back()
      else self.close()
    }, 500)
  }

  function setTextFromError(val) {
    try {
      const response = val.response

      console.log(`setTextFromError() response: ${JSON.stringify(response)}`, val)

      const message =
        (response &&
          response.data &&
          response.data.header &&
          response.data.header.resultCode &&
          `${response.data.header.resultMessage || val.message}`) ||
        // `[${response.data.header.resultCode}] ${response.data.header.resultMessage || val.message}`) ||
        val.message
      const route = useRoute()
      if (!['/login', '/signup'].includes(route.path)) {
        if (
          !response?.data.header.resultCode.startsWith('api.channelApi.') &&
          message.toUpperCase().includes('401 UNAUTHORIZED') &&
          !(message.includes('Shopping Mall API Error:') || message.includes('Integration API Error:'))
        ) {
          if (logoutProcessing.value) return

          setState({ key: 'timeout', value: 1500 })
          setState({ key: 'logoutProcessing', value: true })

          setTimeout(() => {
            setState({ key: 'logoutProcessing', value: false })
            navigateTo('/logout')
          }, 1500)
        }
      }

      setState({ key: 'text', value: message })

      const tokenErrors = [
        'Missing access token',
        'Missing or expired refresh token. Please sign in again.',
        'Invalid refresh token'
      ]
      if (tokenErrors.includes(message)) {
        navigateTo('/logout')
      }

      console.log(`setTextFromError() : ${message}`)
    } catch (e) {
      console.error(`setTextFromError() error: ${e}`)
    }
  }

  function setState(entry) {
    //console.log(`entry: ${JSON.stringify(entry)}`)
    if (entry.key === 'color') {
      color.value = entry.value
    } else if (entry.key === 'show') {
      nextTick(() => {
        show.value = entry.value
      })
    } else if (entry.key === 'text') {
      text.value = entry.value
    } else if (entry.key === 'timeout') {
      timeout.value = entry.value
    } else if (entry.key === 'logoutProcessing') {
      logoutProcessing.value = entry.value
    } else if (entry.key === 'callback') {
      callback.value = entry.value
    }
  }

  return {
    clearSnackbar,
    callback,
    color,
    show,
    location,
    isVertical,
    text,
    timeout,
    logoutProcessing,
    setCallback,
    setColor,
    setShow,
    setText,
    setMessageTimeout,
    showSnackbar,
    showSnackbarNGoBack,
    setTextFromError,
    setState
  }
})
